export default __webpack_public_path__ + "static/court-212c6a590f25db36c79bbfa0087525b8.svg";